module.exports = __webpack_public_path__ + "static/media/backarrow.eaf69b32.svg";